module.exports = __webpack_public_path__ + "img/Carbon1.391ddcba.jpg";